import { create } from 'zustand';

export type SortCol =
  | 'symbol'
  | 'name'
  | 'market_cap'
  | 'last_price'
  | 'last_price_change_pct'
  | 'buzz_score';

export type SortDir = 'asc' | 'desc';

export type Page = 'home' | 'tickers';

interface UiState {
  search: string;
  sortCol: SortCol;
  sortDir: SortDir;
  page: Page;
  setSearch: (s: string) => void;
  setSort: (col: SortCol) => void;
  setPage: (p: Page) => void;
}

export const useUiStore = create<UiState>((set) => ({
  search: '',
  sortCol: 'market_cap',
  sortDir: 'desc',
  page: 'home',
  setSearch: (search) => set({ search }),
  setSort: (col) =>
    set((state) => ({
      sortCol: col,
      sortDir: state.sortCol === col && state.sortDir === 'desc' ? 'asc' : 'desc',
    })),
  setPage: (page) => set({ page }),
}));
